import createAsyncAction from 'shared/utils/createAsyncAction';
import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';

import createAction from './';
import * as services from '../services/fetchAppointments';


export const FETCH_APPOINTMENTS_ESTIMATED_TIME = createAsyncAction(createAction('FETCH_APPOINTMENT_ESTIMATED_TIME'));
export const UPDATE_ESTIMATED_TIME = createAction('UPDATE_ESTIMATED_TIME');

export const fetchAppointmentsEstimatedTime = () => (dispatch, getState) => {
  dispatch({ type: FETCH_APPOINTMENTS_ESTIMATED_TIME.pending });
  const appointmentIds = getState().queues.schedule.appointments.byId;

  const apiCallParams = {
    query: services.FETCH_APPOINTMENTS_ESTIMATED_TIME,
    fetchPolicy: 'no-cache',
    variables: { appointmentIds },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { appointmentsEstimatedTimeToBeServed } }) =>
      dispatch({
        type: FETCH_APPOINTMENTS_ESTIMATED_TIME.success,
        payload: appointmentsEstimatedTimeToBeServed,
      }),
    )
    .catch((err) => dispatch(errorAction(FETCH_APPOINTMENTS_ESTIMATED_TIME.failure, err)));
};

export const onUpdateEstimatedTime = ({ err, data }) => dispatch => {
  if (err) return;
  dispatch({ type: UPDATE_ESTIMATED_TIME, payload: data });
};
